export default {
  确定: '确定',
  取消: '取消',
  重置: '重置',
};
